import './no-match.styl'

function NoMatch() {
  return (
    <div className="no-match">NoMatch</div>
  )
}

export default NoMatch
